export default __webpack_public_path__ + "media/Agents_hero_right_desktop.13dfd3c8f6fc7a9223d0884385701336.svg";